import projects from './projects'
import products from './products'
import dashboard from './dashboard'
// import sales from './sales'
import accounting from './accounting'
import surveys from './surveys'
import teams from './teams'
import externals from './externals'
import pages from './pages'
import academy from './academy'
import odb from './odb'
import oculis from './oculis'

// Array of sections
export default [...dashboard, ...projects, ...surveys, ...products, ...oculis, ...teams, ...externals, ...accounting, ...academy, ...odb]
